var map = {
	"./CircleIcon.vue": [
		"86a9",
		"chunk-2d0dec6c"
	],
	"./SquareIcon.vue": [
		"0163",
		"chunk-2d0a3174"
	],
	"./StarIcon.vue": [
		"9ea7",
		"chunk-2d0f1138"
	],
	"./TriangleIcon.vue": [
		"c13d",
		"chunk-2d216035"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "03c3";
module.exports = webpackAsyncContext;